<template>
    <div class="box">
        <div class="item">
            <div class="item-header">
                <div class="back-btn" @click="handleClick">返回</div>
            </div>
            <div class="item-content">
                <div class="content-item" v-for="info in infoList" :key="info.label">
                    <div class="label">{{ info.label }}</div>
                    <div class="value">{{ info.value }}</div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import {request_get} from "@/utils/request";

export default {
    props: {
        currentDetail: {
            type: [Object, Array],
            default: null
        }
    },
    data() {
        return {
            infoList: []
        }
    },
    watch: {
        currentDetail: {
            handler(val) {
                console.log('currentDetail', val)
              this.getDteail(val.values[6]);
            },
            deep: true,
            immediate: true
        }
    },
    methods:{
      getDteail(id){
        request_get("/lsd/mainBody/get/"+id, {  }, res => {
          if (res.code == 200) {
              let subjectAttribute = {
                1:"生产主体",
                2:"屠宰场",
                3:"生鲜乳企业",
                4:"投入品经营主体",
                5:"加工企业"
              }
            let business = {
              1:"种植业",
              2:"畜牧业",
              3:"水产业",
              4:"其他行业"
            }
            let certifiedProduct = {
              1:"绿色",
              2:"有机",
              3:"地理标志",
              4:"区域公用品牌",
              5:"名特优新"
            }
            let enterpriseType = {
              1:"企业/个体工商户",
              2:"合作社",
              3:"家庭农场",
              4:"个体小散户",
              5:"种植大户",
              6:"其它"
            }
            let farmingUnit = {
              1:"吨",
              2:"亩",
              3:"头",
              4:"尾",
              5:"羽",
              6:"只",
              7:"其他"
            }
            let corporateChampion = {
              1:"国家级",
              2:"省市级",
              3:"地市级"
            }
            let trademark = {
              1:"驰名",
              2:"著名",
              3:"知名"
            }

              this.infoList=[
              { label: '主体名称', value: res.data.bodyName },
              { label: '商标', value: trademark[res.data.trademark] },
              { label: '统一社会信用代码', value: res.data.orgCode },
              { label: '生产产品', value: res.data.farmingProduct },
              { label: '企业类型', value: enterpriseType[res.data.enterpriseType] },
              { label: '规模', value: res.data.farmingScale+farmingUnit[res.data.farmingUnit]?farmingUnit[res.data.farmingUnit]:'' },
              { label: '营业期限', value: res.data.businessTerm },
              { label: '法人', value: res.data.corpName },
              { label: '主体属性', value: subjectAttribute[res.data.subjectAttribute] },
              { label: '联系人', value: res.data.contactName },
              { label: '所属行业', value: business[res.data.business] },
              { label: '联系电话', value: res.data.contactPhone },
              { label: '龙头企业', value: corporateChampion[res.data.corporateChampion] },
              { label: '经纬度', value: res.data.coordinate },
              { label: '国家示范户', value:res.data.nationalDemonstration==1?'是':'否' },
              { label: '详细地址', value: res.data.address },
              { label: '两品一标认证', value: certifiedProduct[res.data.certifiedProduct] }
            ]
          }
        })
      },
        handleClick() {
            this.$emit('handleClick')
        }
    }
}
</script>
<style lang="scss" scoped>
.box{
    display: flex;
    flex-direction: column;
    width:100%;
    height:auto;
    box-sizing: border-box;
    .item{
        width:100%;
        height: auto;
        display: flex;
        flex-direction: column;
        margin-bottom: 15px;
        &:last-of-type{
            margin-bottom: 0;
        }
        .item-header{
            width:100%;
            height:50px;
            position: relative;
            background: url("../../assets/imgs/right_5_title.png") no-repeat;
            background-position: left center;
            background-size: auto 100%;
            .back-btn{
                position: absolute;
                top: 50%;
                right: 20px;
                transform: translateY(-50%);
                color:#fff;
                font-size:16px;
                line-height: 22px;
                cursor: pointer;
            }
        }
        .item-content{
            width:100%;
            flex:none;
            display: flex;
            flex-wrap: wrap;
            margin-top: 15px;
            padding:10px 20px;
            box-sizing: border-box;
            .content-item{
                display: flex;
                align-items: center;
                width: calc((100% - 40px) / 2);
                min-height: 96px;
                padding:0 20px;
                border-bottom:2px solid #51799E;
                box-sizing: border-box;
                &:nth-of-type(odd) {
                    margin-right:40px;
                }
                &:last-of-type{
                    border-bottom: none;
                }
                .label{
                    width: 4em;
                    flex-shrink: 0;
                    color:#A5DFF7;
                    font-size:15px;
                    line-height: 22px;
                    margin-right:20px;
                    white-space: normal;
                    word-break: break-all;
                }
                .value{
                    flex:1;
                    color:#fff;
                    font-size:15px;
                    line-height: 22px;
                    white-space: pre-line;
                }
            }
        }
    }
}
</style>
